module.exports = __webpack_public_path__ + "img/arrow_back_icon.968fee1e.svg";